import { act } from 'react-dom/cjs/react-dom-test-utils.development';
import actions from './actions';

const initState = {
    supplier: {},
    suppliers   : {
        data: []
    },
    loading : false,
    supplierApproved: false,
    message: null,
    type: null,
    ordersAnalytics: [],
    revenueAnalytics: []
};

export default function fetchSuppliersReducer(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_SUPPLIERS_REQUESTED:
            return {
                ...state,
                suppliers   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_SUPPLIERS_SUCCEEDED:
            return {
                ...state,
                suppliers    : action.suppliers,
                loading     : false
            };
        case actions.FETCH_SUPPLIERS_FAILED:
            return {
                ...state,
                loading : false
            };

        case actions.APPROVE_SUPPLIER_REQUESTED:
            return {
                ...state,
                supplierApproved: false,
                loading : true
            };
        case actions.APPROVE_SUPPLIER_SUCCEEDED:
            return {
                ...state,
                supplierApproved : true,
                message : action?.response?.messsage,
                type: "success",
                loading     : false
            };
        case actions.APPROVE_SUPPLIER_FAILED:
            return {
                ...state,
                loading : false,
                message : action?.error,
                type: "danger",
            };
        case actions.FETCH_ORDERS_ANALYTICS_REQUESTED:
            return {
                ...state,
                ordersAnalytics: [],
                loading : true,
            }
        case actions.FETCH_ORDERS_ANALYTICS_SUCCEEDED:
            return {
                ...state,
                loading : false,
                ordersAnalytics: action.ordersAnalytics,
            }
         case actions.FETCH_ORDERS_ANALYTICS_FAILED:
            return {
                ...state,
                loading : false
            }
        case actions.FETCH_REVENUE_REQUESTED:
            return {
                ...state,
                revenueAnalytics: [],
                loading : true,
            }
        case actions.FETCH_REVENUE_SUCCEEDED:
            return {
                ...state,
                loading : false,
                revenueAnalytics : action.revenueAnalytics
            }
        case actions.FETCH_REVENUE_FAILED:
            return {
                ...state,
                loading : false
            }
        default:
            return state;
    }
}
